<template>
  <div class="Page Artwork">
    <transition name="Artwork__container">
      <div class="Artwork__container" v-if="oeuvre">
        
        <div class="Artwork__cover">
          <div class="Artwork__name" v-if="this.oeuvre[this.lang].infos.voix">
            <div class="Artwork__title">{{ oeuvre[oeuvre.titre_original].title }}</div>
            <div class="Artwork__author">{{ oeuvre.author }} / {{ this.oeuvre.year }}</div>
          </div>
          <div @click="close" class="Close" />

          <div class="Artwork__oeuvre" v-if="$route.params.id != 214 && $route.params.id != 226">
            <img class="Vlazy" v-lazy="oeuvre.image.sizes.large" />
          </div>

          <VideoComp 
            :indice="($route.params.id == 214) ? 'adad' : 'patrick'" 
            v-if="$route.params.id == 214 || $route.params.id == 226"/>

          <transition name="Artwork__article">
            <div class="Artwork__article" v-if="article">
              <div class="Artwork__article-title">{{ oeuvre[oeuvre.titre_original].title }}</div>
              <div class="Artwork__article-author">{{ oeuvre.author }}</div>
              <div class="Artwork__article-desc" v-html="oeuvre[lang].infos.article" />
            </div>
          </transition>
        </div>
      
         <div 
          class="Btn" 
          @click="playMusic"
          :class="{ 'is-play': !play, 'is-pause': play }">
          {{ trans(play ? 'Global.btn.close' : 'Global.btn.commentary') }}
          <audio ref="audio" :src="this.oeuvre[this.lang].infos.voix" class="Artwork__audio" />
        </div>

       <!--  <div class="Btn is-left" @click="article = !article" :class="{ 'is-read': !article, 'is-close': article }">
          {{ trans(article ? 'Global.btn.close' : 'Global.btn.read') }}
        </div> -->

      </div>
      <div class="Artwork__container" v-else-if="$route.params.id == 1000">
        <div @click="close" class="Close portrait" />
        <div class="Artwork__portrait">   
          <Portrait/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import Portrait from '@/components/defis/components/Portrait'
import VideoComp from '@/components/defis/components/VideoComp'

export default {
  name: 'Artwork',
  components: { Portrait, VideoComp },
  data: () => ({
    article: false,
    play: false
  }),
  translations: {
    fr: {
      menu: 'En savoir plus sur les artistes',
      restart: "Réessayer l'expérience",
    },
    en: {
      menu: 'Find out more about the artists',
      restart: "Try the experience again",
    },
  },

  computed: {
    oeuvre() {
      const id = this.$route.params.id
      if(!id) return null
      return _.find(this.$store.getters['app/oeuvres'], oeuvre  => oeuvre.id == this.$route.params.id)
    },
  },
  methods: {
    playMusic(){
      this.article = !this.article
      this.play = !this.play
      this.play
      ? this.$refs.audio.play()
      : this.$refs.audio.pause()
    },
    openRandom() {
      this.$router.push({ name: 'artwork.' + this.lang, params: { id: _.sample(this.oeuvres).id } })
    },
    close() {
      this.article = false
      this.play = false
      if(this.$refs.audio)
        this.$refs.audio.pause()
      this.return3DWorld()
      this.$store.commit('app/CALL_NEXT')
      TweenMax.delayedCall(.25, ()=> this.$router.push({ name: 'artwork.' + this.lang })) 
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Artwork

  &__menu
  &__restart
    bottom inherit
    right inherit
    top 15px

  &__name
    text-align center
    position absolute
    width 100%
    top -70px

  &__author
      font-size 14px
      font-weight 300
      text-transform uppercase

      +max-screen-height(tablet-portrait)
        font-size 12px

  &__title
      font-size 16px
      text-transform uppercase
      font-style italic

  &__author
    font-size 14px

  &__menu
    left 80px
    padding-left 50px
    svg
      position absolute
      left 25px
      width 12px
      transform rotate(-180deg)

  &__restart
    color white
    left 470px
    background linear-gradient(to right, rgba(grad_blue, 1), rgba(grad_green, 1))
    &:hover
      color white

  &__container
    height 100vh
    transition opacity 1s, transform 1s
    &-enter
    &-leave-active
      opacity 0
      transform scale(.7)

    .Btn
      padding-left 40px
      position absolute
      left 50%
      right auto
      transform translateX(-50%)
      width 190px
      +max-screen-height(tablet-portrait)
        bottom 110px

      &:after
        position absolute
        left 15px
        top 50%
        transform translateY(-50%)
        margin-top 0px
        content ' '
        background-size contain
        background-repeat no-repeat
        background-position center center
        width 12px
        height 12px
      &.is-play
        &:after
          background-image url('./img/comment.png')
          width 18px
          height 18px
      &.is-read
        &:after
          background-image url('./img/read.png')
      &.is-close
        &:after
          background-image url('./img/close.png')
      &.is-pause
        &:after
          background-image url('./img/pause.png')

      &.is-left
        left 42%

      &.is-right
        left 58%

  &__portrait
    position fixed
    left 50%
    top 50%
    transform translate(-50%, -50%)

    +max-screen-height(tablet-portrait)
      position fixed
      left 0%
      top 0%
      transform translate(-0%, -0%)

  &__cover
    width 100vw
    max-width 700px
    height 400px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    background-size contain
    background-position center center
    background-repeat no-repeat

    +max-screen-height(tablet-portrait)
      height 286px

    & img 
      max-width 600px
      height 400px

      +max-screen-height(tablet-portrait)
        height 286px

  &__oeuvre 
    display flex 
    justify-content center

  &__text
    position absolute
    bottom -40px
    text-align center
    width 800px
    left 50%
    transform translateX(-50%)

  &__article
    position absolute
    width 80%
    min-width 400px
    left -40%
    padding 20px
    top 72%
    transform translateY(-50%)
    background linear-gradient(to bottom, #39282f, #29233d 70%)
    transition opacity 1s, transform 1s

    +max-screen-height(tablet-portrait)
      left -15%
      top 75%

    &-enter
    &-leave-active
      opacity 0
      transform translate(-30px, -50%)
    &-title
      font-size 24px
      +max-screen-height(tablet-portrait)
        font-size 20px
    &-author
      font-size 18px
      margin-bottom 20px
      +max-screen-height(tablet-portrait)
        font-size 16px
    &-desc
      font-size 18px
      line-height 22px

      +max-screen-height(tablet-portrait)
        font-size 14px
        line-height 20px

.Close
  right 0px
  &.portrait
    left calc(50% + 200px)
    top calc(50% - 200px)
    transform translate(-50%, -50%)
    z-index 10000

</style>



// WEBPACK FOOTER //
// src/pages/artwork/Artwork.vue